import type { Meta, StoryObj } from "@storybook/react";

import type { TaskOverviewCardProps } from "@/ui/components/tasks/TaskOverviewCard";
import TasksOverviewCard from "@/ui/components/tasks/TaskOverviewCard";

const TasksOverviewCardMeta: Meta<TaskOverviewCardProps> = {
  args: {
    duration: "30 min",
    taskTitle: "Check blood pressure and log results",
  },
  argTypes: {
    duration: { control: "text" },
    onPress: { action: "onPress" },
    patientName: { control: "text" },
    taskTitle: { control: "text" },
  },
  component: TasksOverviewCard,
  title: "Components/Tasks/TaskOverviewCard",
};

type Story = StoryObj<TaskOverviewCardProps>;

const Primary: Story = {};

const WithPatient: Story = {
  args: {
    patientName: "John",
  },
};

export { Primary, WithPatient };
export default TasksOverviewCardMeta;
